import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiPutPoolMembershipManagementSelections = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'savePoolMembershipManagementSelections',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.put(serviceUrl, {
    impcCodes: payload.params.impcCodes,
  });
};

export default apiPutPoolMembershipManagementSelections;
